module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGcf2c915b1cd87f4b48a8059aab2baec4.cf2c915b.png";